import { Row } from '@tanstack/react-table'
import { commonActionColumn } from '@utils/assessmentReportUtils'
import { Progress } from 'antd'

import { Database_Procs_TeamBonusGames_Item } from '@suntex.fim/api-client'
import { ColumnType, Tooltip } from '@suntex.fim/ui'

import {
  generateScrollableAssessmentCommonColumns,
  renderWrappedAssessmentHeader
} from './CommonColumns'

/**
 * handles hidable columns list
 */
export const hidableSelectLabel: Record<string, string> = {
  userId: 'User ID',
  displayName: 'Display Name',
  stickers: 'Stickers',
  k2_pundis_puzzle_ct: `K-2 Pundi's CT`,
  k2_rps_ct: 'K-2 RPS Chess CT',
  k2_monus_path_ct: `K-2 Monu's Path Coding`,
  k2_misfits_num_ct: 'K2 Number Misfits Coding',
  k2_missing_icons_ct: 'K-2 Coding Missing Icons',
  k2_what_belongs_ct: 'K-2 What Belongs',
  misfits_newb: 'Misfits Newb',
  rps_newb_ct: 'CT RPS Newb',
  misfits_num: 'Misfits Whole Numbers',
  rps_ct: 'CT RPS Elite',
  pundis_puzzle_ct: `CT Pundi's Puzzle`,
  zero_sum_newb: 'Zero Sum Newb',
  misfits_dec: 'Misfits Decimals',
  misfits: 'Misfits Elite',
  misfits_frc: 'Misfits Fractions',
  rps_master_ct: 'CT RPS Epic',
  zero_sum: 'Zero Sum',
  misfits_master: 'Misfits Epic',
  factor_wheels_ct: 'Factor Wheels'
}

export const getCTColumnKeys = (level: number) => {
  // Initialize the columnKeys
  let columnKeys = [
    'k2_pundis_puzzle_ct',
    'k2_rps_ct',
    'k2_monus_path_ct',
    'k2_misfits_num_ct',
    'k2_missing_icons_ct',
    'k2_what_belongs_ct'
  ]
  // As per the level modify the columnKeys
  switch (level) {
    case 1:
      columnKeys = [
        'misfits_newb',
        'rps_newb_ct',
        'misfits_num',
        'rps_ct',
        'pundis_puzzle_ct',
        'zero_sum_newb'
      ]
      break
    case 2:
      columnKeys = [
        'misfits_dec',
        'misfits',
        'misfits_frc',
        'rps_master_ct',
        'zero_sum',
        'misfits_master',
        'factor_wheels_ct'
      ]
      break
    default:
      columnKeys = [
        'k2_pundis_puzzle_ct',
        'k2_rps_ct',
        'k2_monus_path_ct',
        'k2_misfits_num_ct',
        'k2_missing_icons_ct',
        'k2_what_belongs_ct'
      ]
      break
  }

  return columnKeys
}

/**
 * returns JSX for computational thinking report table
 */
function columns({
  level,
  graphColor,
  sendMessage
}: {
  level: number
  graphColor: string
  sendMessage: (t: Row<Database_Procs_TeamBonusGames_Item>[]) => void
}) {
  const columnKeys = getCTColumnKeys(level)
  /**
   * renders progress bar in table cell
   */
  const levelColumns: ColumnType<Database_Procs_TeamBonusGames_Item>[] =
    columnKeys.map((key) => ({
      header: () => renderWrappedAssessmentHeader(`${hidableSelectLabel[key]}`),
      accessorKey: key,
      id: key,
      size: 110,
      cell: (info) => (
        <Tooltip
          title={`${Number(info.getValue()) || 0}% complete`}
          classNames={{ root: 'progress-tooltip' }}
          arrow={false}
          placement="right"
        >
          <Progress
            strokeColor={graphColor}
            percent={Number(info.getValue()) || 0}
            size={['100%', 32]}
            showInfo={false}
          />
        </Tooltip>
      )
    }))

  const actioncolumn = commonActionColumn<Database_Procs_TeamBonusGames_Item>(
    hidableSelectLabel,
    sendMessage
  )

  /**
   * handles table column mapping
   */
  const finalColumns: ColumnType<Database_Procs_TeamBonusGames_Item>[] = [
    actioncolumn,
    ...generateScrollableAssessmentCommonColumns<Database_Procs_TeamBonusGames_Item>(),
    ...levelColumns
  ]
  return finalColumns
}

export default columns
